var initializeFlightSearchMask = function () {
    window['tuiCottonBall'].subscribe('tui-flights-search-form', '*', 'search', function (componentName, scope, eventName, data) {
        var params = new Array();
        for (var key in data) {
            params.push(key + '=' + data[key]);
        }
        window.location.href = 'flug/suchen?' + params.join('&');
    });
};
export default initializeFlightSearchMask;
